import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from '@thd-olt-component-react/grid';
import { GROUP_TYPES } from '../helpers';
import { AttributeContent } from './AttributeContent';
import './specifications.scss';

export const SpecificationGroupContent = ({ specificationGroup }) => (
  <>
    {(specificationGroup)
      .filter((group) => group.specTitle === GROUP_TYPES.DIMENSIONS)
      .map((attrGroupList, i) => (
        <Row key={i}>
          <Col nopadding>
            <h4 className="specifications__title">{attrGroupList.specTitle}</h4>
            <AttributeContent attributeGroupList={attrGroupList} />
          </Col>
        </Row>
      ))}
    {(specificationGroup)
      .filter((group) => group.specTitle === GROUP_TYPES.DETAILS)
      .map((attrGroupList, i) => (
        <Row key={i}>
          <Col nopadding>
            <h4 className="specifications__title specifications__title__paddingtop">{attrGroupList.specTitle}</h4>
            <AttributeContent attributeGroupList={attrGroupList} />
          </Col>
        </Row>
      ))}
    {(specificationGroup)
      .filter((group) => group.specTitle === GROUP_TYPES.WARRANTY)
      .map((attrGroupList, i) => (
        <Row key={i}>
          <Col nopadding>
            <h4 className="specifications__title specifications__title__paddingtop">{attrGroupList.specTitle}</h4>
            <AttributeContent attributeGroupList={attrGroupList} />
          </Col>
        </Row>
      ))}
    <Row>
      <Col nopadding>
        <div id="thdFeedbackPip" className="specifications__link" suppressHydrationWarning />
      </Col>
    </Row>
  </>
);

SpecificationGroupContent.displayName = 'SpecificationGroupContent';

SpecificationGroupContent.propTypes = {
  specificationGroup: PropTypes.arrayOf(PropTypes.shape({}))
};

SpecificationGroupContent.defaultProps = {
  specificationGroup: null
};
